// Ã‚Â© 2026 Holmes Computer Consultants. All rights reserved.
import type {BufferGeometry,Group,Material} from 'three'
import type {CabinetDimensions} from './cabinet'
type Builder=(group:Group,dims:CabinetDimensions,geometries:BufferGeometry[],materials:Material[])=>boolean
let builder:Builder|undefined
export function registerPlungerFactory(value:Builder):void{builder=value}
export function assembleCabinetPlunger(group:Group,dims:CabinetDimensions,geometries:BufferGeometry[],materials:Material[]):boolean{return builder?.(group,dims,geometries,materials)??false}
